import ForgetPassword from "../../../../jsx/pages/Customer/ForgotPassword";

const LoginWrapper = function (props) {
  return <ForgetPassword />;
};

export default constore(LoginWrapper);
